import TomSelect from "tom-select";
// CDN 時代と同じ base テーマ (tom-select.css) を使う。navi (atom_select_controller) も同じテーマ。
import "tom-select/dist/css/tom-select.css";
// Tom Select (.searchable-select / .multiselect-checkbox-options) を
// ok-form の素の select とサイズ感を揃えるスコープ付き override
import "../../stylesheets/mgmt/tom_select.css";

// mgmt 全画面共通の Tom Select 初期化。
// 各画面の _js_load_select_option 等は el.tomselect プロパティ経由でこのインスタンスを参照するため、
// それらの DOMContentLoaded リスナーより先に登録される (= head で読み込まれる) 必要がある。
window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll<HTMLSelectElement>(".multiselect-checkbox-options").forEach((el) => {
    new TomSelect(el, {
      plugins: ["checkbox_options"],
      // issue #1955: data-placeholder 属性でプレースホルダを指定できる (選択済み項目があれば隠す)
      placeholder: el.dataset.placeholder,
      hidePlaceholder: true,
    });
  });

  // issue #2204: 選択肢がレコード数に比例して伸びる単一選択 select を検索可能にする。
  // option の動的差し替えは el.tomselect の API (clear/clearOptions/addOption) 経由で行うこと
  // (innerHTML の直接書き換えは Tom Select の表示に反映されない)。
  document.querySelectorAll<HTMLSelectElement>(".searchable-select").forEach((el) => {
    // issue #2219: include_blank / prompt の空 option (「全て」「選択してください」等) は
    // 選択肢としては表示せず placeholder として使う (「全て」と空行の意味重複を避ける)。
    // 未選択に戻す操作はクリアボタンで提供する。
    const emptyOption = Array.from(el.options).find((option) => option.value === "");
    new TomSelect(el, {
      plugins: emptyOption ? { clear_button: { title: "選択を解除" } } : {},
      placeholder: el.dataset.placeholder ?? emptyOption?.text,
      // 既定の 50 件でドロップダウンが打ち切られないように全件表示する
      maxOptions: undefined,
    });
  });
});
